import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState } from "react";
import { toast } from "sonner";

export const useAssign = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);

  const assignSingle = async (assignment: {
    preference: string;
    exploration: string;
  }) => {
    try {
      setLoading(true);
      const response = await api(
        "/enrollments/assign",
        {
          method: "POST",
          body: {
            assignments: [assignment],
          },
        },
        dispatch,
      );
      toast.success(response.message);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const assignBulk = async (
    assignments: { preference: string; exploration: string }[],
  ) => {
    try {
      setLoading(true);
      const response = await api(
        "/enrollments/assign",
        {
          method: "POST",
          body: {
            assignments,
          },
        },
        dispatch,
      );
      toast.success(response.message);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { assignSingle, assignBulk, loading };
};
